module.exports = __webpack_public_path__ + "img/no_profit-8f5a7003.02177170.png";